import {
  Component,
  Output,
  EventEmitter,
  ViewChild,
  ViewContainerRef,
  Input,
  HostListener,
  ChangeDetectorRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'dynamic-scaffold-dialog',
  templateUrl: './scaffold-dialog-frame.component.html',
  styleUrl: './scaffold-dialog-frame.component.scss',
  standalone: true,
  imports: [CommonModule],
})
export class ScaffoldDialogFrameComponent {
  private _settings: any;
  @Input()
  set settings(value: any) {
    this._settings = value;
    this.cd.detectChanges();
  }
  get settings(): any {
    return this._settings;
  }
  @Output() closed = new EventEmitter<void>();
  @ViewChild('content', { read: ViewContainerRef, static: true })
  viewContainerRef!: ViewContainerRef;

  constructor(private cd: ChangeDetectorRef) {}

  close() {
    if (this.settings?.closeOnBackdropClick) {
      this.closed.emit();
    }
  }

  closeFromButton() {
    this.closed.emit();
  }

  isolate(event: Event) {
    event.stopPropagation();
    const target = event.target as HTMLElement;
    const isInteractiveElement =
      target.tagName === 'INPUT' ||
      target.tagName === 'BUTTON' ||
      target.tagName === 'SELECT' ||
      target.tagName === 'TEXTAREA' ||
      target.closest('button') ||
      target.closest('input') ||
      target.closest('select') ||
      target.closest('textarea') ||
      target.closest('p-checkbox') ||
      target.closest('a');

    if (!isInteractiveElement) {
      event.preventDefault();
    }
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscapeKeydown(event: KeyboardEvent) {
    if (this.settings?.closeOnEsc) {
      this.closed.emit();
    }
  }
}
